import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class PublishedDateFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled: boolean) {
        super(Features.PublishedDate, "MultiJurisdictionCms.Dto.Features.PublishedDateFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.PublishedDateFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}